import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "svg-icon",
  "aria-hidden": "true"
};
const _hoisted_2 = ["xlink:href"];
const _hoisted_3 = {
  class: "svg-icon",
  "aria-hidden": "true"
};
const _hoisted_4 = ["xlink:href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_router_link = _resolveComponent("router-link");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  return _openBlock(), _createBlock(_component_el_menu, {
    "default-active": "store1.state.editableTabsValue",
    ruoter: "",
    "background-color": "#c4ee81",
    "text-color": "black",
    "active-color": "#ffd04b",
    class: "el-menu-vertical-demo"
  }, {
    default: _withCtx(() => [_createVNode(_component_router_link, {
      to: "/index.toString()"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "Index.toString()",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.selectMenu({
          name: 'Index.toString()',
          title: '首页'
        }))
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("template", {
          slot: "title"
        }, [_createElementVNode("i", {
          class: "el-icon-s-home"
        }), _createElementVNode("span", {
          slot: "title"
        }, "首页")], -1)]))]),
        _: 1
      })]),
      _: 1
    }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, menu => {
      return _openBlock(), _createBlock(_component_el_sub_menu, {
        index: menu.name.toString()
      }, {
        title: _withCtx(() => [(_openBlock(), _createElementBlock("svg", _hoisted_1, [_createElementVNode("use", {
          "xlink:href": '#icon-' + menu.icon
        }, null, 8, _hoisted_2)])), _createElementVNode("span", null, _toDisplayString(menu.title), 1)]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, item => {
          return _openBlock(), _createBlock(_component_router_link, {
            to: item.path
          }, {
            default: _withCtx(() => [_createVNode(_component_el_menu_item, {
              index: item.name.toString(),
              onClick: $event => _ctx.selectMenu(item)
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock("svg", _hoisted_3, [_createElementVNode("use", {
                "xlink:href": '#icon-' + item.icon
              }, null, 8, _hoisted_4)])), _createElementVNode("span", null, _toDisplayString(item.title), 1)]),
              _: 2
            }, 1032, ["index", "onClick"])]),
            _: 2
          }, 1032, ["to"]);
        }), 256))]),
        _: 2
      }, 1032, ["index"]);
    }), 256))]),
    _: 1
  });
}